import { render, staticRenderFns } from "./CreateEventPopup.vue?vue&type=template&id=57b6327c&scoped=true"
import script from "./CreateEventPopup.vue?vue&type=script&lang=js"
export * from "./CreateEventPopup.vue?vue&type=script&lang=js"
import style0 from "./CreateEventPopup.vue?vue&type=style&index=0&id=57b6327c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6327c",
  null
  
)

export default component.exports